import UriTemplate from 'uri-templates';

function AffiliateModel($q, BBModel, BaseModel, halClient, $rootScope) {
    'ngInject';

    class Affiliate extends BaseModel {

        constructor(data) {
            super(data);
            this.test = 1;
        }

        /***
         * @ngdoc method
         * @name getCompanyByRef
         * @methodOf BB:Affiliate
         * @description
         * Find a company in according to reference
         *
         * @param {string} ref A reference to find a company based on it
         *
         * @returns {promise} A promise for the company reference
         */
        getCompanyByRef(ref) {

            const prms = {
                id: this.cookie,
                reference: ref
            };

            const href = `${$rootScope.bb.api_url}/api/v1/affiliates/{id}/companies/{reference}`;
            const uri = new UriTemplate(href).fillFromObject(prms || {});

            const defer = $q.defer();

            halClient.$get(uri, {}).then((company) => {
                    if (company) {
                        return defer.resolve(new BBModel.Company(company));
                    } else {
                        return defer.reject(`No company for ref ${ref}`);
                    }
                }
                , (err) => {
                    console.log('err ', err);
                    return defer.reject(err);
                });
            return defer.promise;
        }
    }

    return Affiliate;
}

/***
 * @ngdoc service
 * @name BB:Affiliate
 *
 * @description
 * Representation of an Affiliate Object
 *
 * @property {string} affiliate_id Id of the affiliated company
 * @property {string} reference The reference of the affiliated company
 * @property {integer} country_code Country code of the affiliated company
 *///


// helpful functions about a company
angular
    .module('BB')
    .service('AffiliateModel', AffiliateModel);


// WEBPACK FOOTER //
// ../node_modules/bookingbug-angular/src/core/_models/affiliate_model.service.js